import globalAxios from 'axios';

const BASE_PATH = "https://flex-gateway.dev.flexis.team".replace(/\/+$/, "");
class BaseAPI {
  constructor(configuration, basePath = BASE_PATH, axios = globalAxios) {
    this.basePath = basePath;
    this.axios = axios;
    if (configuration) {
      this.configuration = configuration;
      this.basePath = configuration.basePath || this.basePath;
    }
  }
}
class RequiredError extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
    this.name = "RequiredError";
  }
}

export { BASE_PATH, BaseAPI, RequiredError };
//# sourceMappingURL=base.mjs.map
